import { apiCallV2 } from "../utils/api";

const useSession = () => {
    const sessionStart = async (type) => {
        const token = localStorage.getItem("access-token")
        if (token) {
            const res = await apiCallV2(
                "POST",
                "session/start",
                {},
                token,
            );

            // localStorage.setItem("session", res.data.data.session)
        }
    }

    const sessionEnd = async (type) => {
        const token = localStorage.getItem("access-token")
        const session = localStorage.getItem("session")
        if (token) {
            const res = await apiCallV2(
                "POST",
                "session/end",
                {
                    session: session
                },
                token,
            );

            localStorage.setItem("session", null)
        }
    }

    return {
        sessionStart,
        sessionEnd,
    };
}

export default useSession;
